import Profile from "@/domain/entities/user/Profile";
import {
    IDateValue,
    Profile as ProfileMailvista,
} from "@cs_teamwaydev/mailvista-sdk_react";

const profileToDomainMapper = (profile: ProfileMailvista): Profile =>
    new Profile({
        registrationDate: new Date(profile.registrationDate || new Date()),
        unregistrationDate: new Date(profile.unregistrationDate || new Date()),
        lastLoginDate: new Date(profile.lastLoginDate || new Date()),
        email: profile.email,
        displayName: profile.displayName,
    });

const profileToSDKMapper = (profile: Profile): ProfileMailvista => ({
    registrationDate:
        (profile.registrationDate as unknown as IDateValue) || undefined,
    unregistrationDate:
        (profile.unregistrationDate as unknown as IDateValue) ||
        (new Date() as unknown as IDateValue),
    lastLoginDate:
        (profile.lastLoginDate as unknown as IDateValue) || undefined,
    email: profile.email,
    displayName: profile.displayName,
});

export { profileToDomainMapper, profileToSDKMapper };
